document.addEventListener('alpine:init', () => {
    Alpine.data('MainBanner', () => ({
        showFormSubmit: false,
        onSearchFieldChange(e) {
            this.showFormSubmit = e.target?.value?.length;
        }
    }));
});
